<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1 overflow-hidden min-h-0" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex justify-content-between align-items-start p-2 zx-z-index-1">
    <div *ngIf="isExpress" class="d-flex align-items-center gap-2" style="order: 1;">
      <mat-slide-toggle
        [(ngModel)]="forceRasterize"
        color="primary"
        class="small-toggle">
      </mat-slide-toggle>
      <span class="zx-text-tiny" [class.text-white]="isDarkMode">
        {{ 'su-management.resend-partial-files.force-rasterize-toggle' | translate }}
      </span>
    </div>
    <span *ngIf="!isExpress" style="order: 1;"></span>
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode"
      style="order: 2;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column w-100 min-h-0 overflow-hidden px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-2">

    <h6 class="zx-text-big fw-bold px-2 pt-2 m-0 text-center flex-shrink-0" [class.zx-rtl]="!isRTL" [class.text-white]="isDarkMode">
      {{ 'su-management.resend-partial-files.title' | translate }}
    </h6>

    <div class="d-flex flex-grow-1 w-100 min-h-0 position-relative">
      <div
        class="resend-partial-files-scroll position-absolute h-100 w-100 d-flex flex-column overflow-auto gap-1 gap-lg-2 p-1 p-lg-2 zx-bg-gray-v-light-opacity rounded-2"
        [class.zx-border-gray-25-pr]="isDarkMode">

        <!-- files [plotter] -->
        <ng-container *ngIf="isPlotter">
          <section
            ngClass="d-flex w-100 row p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 gap-2 gap-md-0"
            [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
            *ngFor="let file of files; index as i" class="d-flex w-100 flex-column">

            <div class="d-flex align-items-center gap-2 w-100 pb-2" [class.flex-row-reverse]="!isRTL">
              <mat-checkbox color="primary" [checked]="isFileChecked(i)"
                (change)="onFileCheckboxChange(i, $event.checked)"></mat-checkbox>
              <span class="zx-text-small zx-text-pink flex-grow-1"
                [class.text-start]="!isRTL" [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode"
                [class.zx-ltr]="!isRTL">
                <span>{{ getDisplayFileNameAfterSplit(file) }}</span>
                <span *ngIf="file.images.length > 1" class="fw-normal text-green">
                  <span class="zx-100-opacity"> -- </span>
                  ({{ file.images.length }} {{ 'printing-table.pages-short' | translate }})
                </span>
              </span>
            </div>

            <article *ngFor="let image of file.images; index as j"
              class="d-flex align-items-center gap-2 gap-lg-3 p-0"
              [class.zx-border-gray-top-25-pr]="file.images.length > 1"
              [class.zx-border-gray-left-25-pr-md]="j % 2 === 0 && file.images.length > 1"
              [class.flex-row-reverse]="!isRTL" [class.col-12]="file.images.length === 1"
              [class.py-1]="file.images.length > 1" [class.py-lg-2]="file.images.length > 1"
              [class.ps-md-2]="file.images.length > 1 && j % 2 === 0"
              [class.pe-md-2]="file.images.length > 1 && j % 2 !== 0"
              [class.col-md-6]="file.images.length > 1">

              <mat-checkbox color="primary" [checked]="isPageChecked(i, j)"
                (change)="onPageCheckboxChange(i, j, $event.checked)"></mat-checkbox>

              <article
                class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                <div class="d-flex zx-medium-plus-icon-size rounded-1">
                  <img *ngIf="getPlotterImageSrc(i, j)" class="w-100 h-100 object-fit-contain"
                    [src]="getPlotterImageSrc(i, j)" alt="File Page Image">
                </div>
                <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                  <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                    <span>{{ getPlotterDimension(image, 'height') }}</span>
                    <span> × </span>
                    <span>{{ getPlotterDimension(image, 'width') }}</span>
                    <span class="zx-text-tiny-tiny">{{ 'printing-table.dimensions-cm' | translate }}</span>
                  </span>
                </div>
                <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0">
                  <span class="p-1 p-lg-2 zx-bg-light">
                    <div class="d-flex align-items-center text-green zx-text-tiny" [class.flex-row-reverse]="isRTL">
                      <span>{{ j + 1 }}</span><span>/</span><span>{{ file.images.length }}</span>
                    </div>
                  </span>
                </article>
              </article>

              <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">
                <div class="d-flex flex-column gap-1 gap-lg-2">
                  <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <b *ngIf="getPlotterPaperSerialName(image)" class="zx-text-tiny"
                        [class.zx-text-white]="isDarkMode">
                        {{ 'paper-type.name-short.' + getPlotterPaperSerialName(image) | translate }}
                      </b>
                      <b *ngIf="!getPlotterPaperSerialName(image)" class="zx-text-tiny text-red"
                        [class.zx-text-white]="isDarkMode">
                        {{ 'printing-table.image-no-paper' | translate }}
                      </b>
                    </div>
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="!getPrintSettings(image).bw">{{ 'printing-table.color-color' | translate }}</span>
                        <span *ngIf="getPrintSettings(image).bw">{{ 'printing-table.color-bandw' | translate }}</span>
                      </span>
                    </div>
                    <div *ngIf="file.images.length === 1" class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                        <span *ngIf="getPlotterScale(image) > 1">{{ 'order-summary-resize-bigger' | translate }}</span>
                        <span *ngIf="getPlotterScale(image) < 1">{{ 'order-summary-resize-smaller' | translate }}</span>
                        <span *ngIf="getPlotterScale(image) === 1">{{ 'order-summary-resize-original' | translate }}</span>
                        <span *ngIf="getPlotterScale(image) !== 1" [class.zx-ltr]="!isRTL">
                          <span *ngIf="isRTL">%</span>
                          <span>{{ roundDownTowDecimalCeil(getPlotterScale(image) * 100) }}</span>
                          <span *ngIf="!isRTL">%</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="!getPrintSettings(image).centered">{{ 'order-summary-not-centered' | translate }}</span>
                        <span *ngIf="getPrintSettings(image).centered">{{ 'order-summary-is-centered' | translate }}</span>
                      </span>
                    </div>
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="!getPrintSettings(image).cmFromTop">{{ 'order-summary-not-borders' | translate }}</span>
                        <span *ngIf="getPrintSettings(image).cmFromTop">{{ 'order-summary-is-borders' | translate }}</span>
                      </span>
                    </div>
                    <div *ngIf="getPrintSettings(image).numOfCopies !== 1"
                      class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span>{{ getPrintSettings(image).numOfCopies }}</span>
                        <span>{{ 'printing-table.copies-short' | translate }}</span>
                      </span>
                    </div>
                  </div>
                  <div *ngIf="file.images.length > 1" class="d-flex gap-1 gap-lg-2 align-items-center"
                    [class.flex-row-reverse]="!isRTL">
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                        <span *ngIf="getPlotterScale(image) > 1">{{ 'order-summary-resize-bigger' | translate }}</span>
                        <span *ngIf="getPlotterScale(image) < 1">{{ 'order-summary-resize-smaller' | translate }}</span>
                        <span *ngIf="getPlotterScale(image) === 1">{{ 'order-summary-resize-original' | translate }}</span>
                        <span *ngIf="getPlotterScale(image) !== 1">
                          <span *ngIf="isRTL">%</span>
                          <span>{{ roundDownTowDecimalCeil(getPlotterScale(image) * 100) }}</span>
                          <span *ngIf="!isRTL">%</span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            </article>
          </section>
        </ng-container>

        <!-- files [express] -->
        <ng-container *ngIf="isExpress">
          <section
            ngClass="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
            [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
            *ngFor="let file of files; index as i" class="d-flex w-100">

            <div class="d-flex align-items-center gap-2 w-100 pb-2" [class.flex-row-reverse]="!isRTL">
              <mat-checkbox color="primary" [checked]="isFileChecked(i)"
                (change)="onFileCheckboxChange(i, $event.checked)"></mat-checkbox>
              <span class="zx-text-small zx-text-pink flex-grow-1" [class.fw-bold]="!isDarkMode"
                [class.zx-text-white]="isDarkMode">
                {{ getDisplayFileNameAfterSplit(file) }}
              </span>
            </div>

            <article class="d-flex align-items-center gap-2 gap-lg-3 w-100" [class.flex-row-reverse]="!isRTL">
              <mat-checkbox color="primary" [checked]="isPageChecked(i, 0)"
                (change)="onPageCheckboxChange(i, 0, $event.checked)"></mat-checkbox>

              <article
                class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                <div class="d-flex zx-medium-plus-icon-size rounded-1">
                  <img *ngIf="getExpressImageSrc(i, 0)" class="w-100 h-100 object-fit-contain"
                    [src]="getExpressImageSrc(i, 0)" alt="File Page Image">
                </div>
                <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                  <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                    <span>{{ file.images[0]?.height }}</span><span>×</span><span>{{ file.images[0]?.width }}</span>
                    <span class="zx-text-tiny-tiny">{{ 'printing-table.dimensions-cm' | translate }}</span>
                  </span>
                </div>
                <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0"
                  [class.flex-row-reverse]="!isRTL">
                  <span class="p-1 p-lg-2 zx-bg-light">
                    <div class="d-flex align-items-center text-green zx-text-tiny" [class.flex-row-reverse]="isRTL">
                      <span>1</span><span>/</span><span>{{ file.images.length }}</span>
                    </div>
                  </span>
                </article>
              </article>

              <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">
                <div class="d-flex flex-column gap-1 gap-lg-2">
                  <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <b *ngIf="getExpressPaperSerialName(file)" class="zx-text-tiny zx-text-sm-small"
                        [class.zx-text-white]="isDarkMode">
                        {{ 'paper-type.name-short.' + getExpressPaperSerialName(file) | translate }}
                      </b>
                      <b *ngIf="!getExpressPaperSerialName(file)" class="zx-text-tiny zx-text-sm-small text-red"
                        [class.zx-text-white]="isDarkMode">
                        {{ 'printing-table.image-no-paper' | translate }}
                      </b>
                    </div>
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="!getPrintSettings(file).bw">{{ 'printing-table.color-color' | translate }}</span>
                        <span *ngIf="getPrintSettings(file).bw">{{ 'printing-table.color-bandw' | translate }}</span>
                      </span>
                    </div>
                    <div *ngIf="getPrintSettings(file).numOfCopies !== 1"
                      class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                        <span>{{ getPrintSettings(file).numOfCopies }}</span>
                        <span>{{ 'printing-table.copies-short' | translate }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="!getPrintSettings(file).doubleSided">{{ 'printing-table.sides-one' | translate }}</span>
                        <span *ngIf="getPrintSettings(file).doubleSided">{{ 'printing-table.sides-two' | translate }}</span>
                      </span>
                    </div>
                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="!getPrintSettings(file).fit && !getPrintSettings(file).cropRatio">
                          {{ 'order-summary-resize-original' | translate }}
                        </span>
                        <span *ngIf="getPrintSettings(file).fit && !getPrintSettings(file).cropRatio">
                          {{ 'order-summary-resize-maximal' | translate }}
                        </span>
                        <span *ngIf="getPrintSettings(file).cropRatio">
                          {{ 'order-summary-resize-crop' | translate }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            </article>

            <article *ngIf="file.images.length > 1" class="d-flex row w-100 pt-1" [class.zx-ltr]="!isRTL">
              <div *ngFor="let image of file.images; let j = index" [class.d-none]="j === 0"
                class="col-4 col-sm-3 col-md-2 pb-1 d-flex flex-column align-items-center gap-1">
                <mat-checkbox color="primary" [checked]="isPageChecked(i, j)"
                  (change)="onPageCheckboxChange(i, j, $event.checked)"></mat-checkbox>
                <article
                  class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light w-100">
                  <div class="d-flex zx-medium-plus-icon-size rounded-1">
                    <img *ngIf="getExpressImageSrc(i, j)" class="w-100 h-100 object-fit-contain"
                      [src]="getExpressImageSrc(i, j)" alt="File Page Image">
                  </div>
                  <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                    <span class="zx-text-tiny">
                      <span>{{ image?.height }}</span><span>×</span><span>{{ image?.width }}</span>
                      <span class="zx-text-tiny-tiny">{{ 'printing-table.dimensions-cm' | translate }}</span>
                    </span>
                  </div>
                  <article class="position-absolute d-flex w-100 top-0">
                    <span class="p-1 p-lg-2 zx-bg-light">
                      <div class="d-flex align-items-center text-green zx-text-tiny" [class.flex-row-reverse]="isRTL">
                        <span>{{ j + 1 }}</span><span>/</span><span>{{ file.images.length }}</span>
                      </div>
                    </span>
                  </article>
                </article>
              </div>
            </article>
          </section>
        </ng-container>

      </div>
    </div>

    <div class="d-flex justify-content-center w-100 pt-2 flex-shrink-0">
      <button type="button" mat-raised-button (click)="onResend()"
        [disabled]="isSubmitting || !canResend"
        class="rounded-pill fw-bold text-white resend-partial-files-btn">
        {{ 'su-management.resend-order' | translate }}
      </button>
    </div>
  </div>
</div>
